<div class="page-title">
  <h1>Análise postural</h1>
</div>

<section class="primeiro-container">
  <div class="container-toggles">
    <button
      class="seletor-tela"
      [ngClass]="{'botao-ativo': telaExibida == 1}"
      (click)="telaExibida=1"
    >
      Importar
    </button>
    <button
      class="seletor-tela"
      [ngClass]="{'botao-ativo': telaExibida == 2}"
      (click)="telaExibida=2"
    >
      Histórico
    </button>
  </div>
</section>

@if (telaExibida == 1) {
<div>
  <app-analise-postural
    (mudarTela)="mudarTela($event)"
  ></app-analise-postural>
</div>
} @if (telaExibida == 2) {
<div class="tela-historico">
  <app-historico-analise-postural></app-historico-analise-postural>
</div>
}
